module.exports = __webpack_public_path__ + "img/hederkooshel.ef4b54a6.svg";